import Input from '../../../../components/form/Input'
import { ImageUploadCard } from '../../../../components/ImageUploadCard'
import { useDispatch, useSelector } from 'react-redux'
import { setPageTabData } from '../../../../redux/slices/dynamicUiSlice'
import LabeledSelect from '../../../../components/selects/LabeledSelect'
import Checkbox from '../../../../components/form/CheckBox'
import {
  PAGE_TAB_TYPES,
  UI_FOCUSED_TYPE_BRAND,
  UI_FOCUSED_TYPE_CATEGORY,
  UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN,
} from '../../constants'
import { setLoading as setDynamicLoading } from '../../../../redux/slices/dynamicElementsSlice'
import DynamicSearchSelect from '../../../../components/selects/DynamicSearchSelect'

const PageStickyTabsContent = () => {

  const isLoading = useSelector((state) => state.dynamicElements.editing.loading)
  const selected = useSelector((state) => state.dynamicUi.pages.tabs.selected)
  const editTab = useSelector((state) => state.dynamicUi.pages.tabs.edit)

  const selectedGroup = useSelector((state) => (state.dynamicUi.pages.selectedGroup))
  const pageData = useSelector((state) => (state.dynamicUi.pages[selectedGroup].data))
  const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage))

  const isVertical = pageData[selectedPage]?.is_vertical


  const dispatch = useDispatch()

  const selectedTab = editTab[selected]

  const onTitleChange = (e) => {
    if (e.target.value.trim().length <= MAX_TITLE_LENGTH) {
      dispatch(setPageTabData({ edit: true, values: { title: e.target.value } }))
    }

  }

  const onTitleImageChange = (url) => {
    dispatch(setPageTabData({ edit: true, values: { image_url: url } }))
  }

  const onIsQuickeeChange = () => {
    dispatch(setPageTabData({ edit: true, values: { is_quickee: !selectedTab?.is_quickee } }))
  }

  return (

    <div
      className={`border border-gray-200 px-4 py-6 rounded-md grid grid-cols-2 gap-6 relative overflow-hidden ${selectedTab?.id ? '' : 'bg-secondary-100'}`}>
      {!selectedTab?.id &&
        <div
          className="absolute text-xs top-0 left-0 font-bold bg-secondary-500 text-white px-4 py-0.5 rounded-br-md">New
          Tab</div>
      }
      <div className={`${isVertical ? "flex-col-reverse" : "flex-col"} flex`}>
        <Input
          label="Tab Title"
          value={selectedTab?.title ?? ''}
          onChange={onTitleChange}
          disabled={isLoading}
          formLabelTrailing={<span className="text-xs font-normal">Max {MAX_TITLE_LENGTH} characters</span>}
          // maxLength={MAX_TITLE_LENGTH}
          isRequired={!isVertical}
        />
        <ImageUploadCard
          className={`${isVertical ? "mb-5" : "mb-0"}`}
          // permanentRemove={false}
          confirmation={false}
          initialImage={selectedTab?.image_url ?? ''}
          title="Tab Image"
          isRequired={isVertical}
          onImageUploaded={onTitleImageChange}
          onImageRemoved={onTitleImageChange}
          setCustomLoading={(loading) => dispatch(setDynamicLoading({ loading, element: 'editing' }))}
          disabled={isLoading}
          formLabelTrailing={
            <div className="text-xs font-normal leading-snug sm:leading-snug">
              Aspect Ratio: 1
            </div>}
        />

      </div>

      {selectedTab && <TabValueSelector values={selectedTab} onIsQuickeeChange={onIsQuickeeChange} />}

    </div>
  )
}

export default PageStickyTabsContent

const TabValueSelector = ({ values, onIsQuickeeChange }) => {

  const isLoading = useSelector((state) => state.dynamicElements.editing.loading)

  const dispatch = useDispatch()

  const setTabType = (type) => {
    dispatch(setPageTabData({ edit: true, values: { type: type.value } }))
  }

  const setTabValue = (value) => {
    dispatch(setPageTabData({ edit: true, values: { obj: value } }))
  }

  const setCampaignType = (value) => {
    dispatch(setPageTabData({ edit: true, values: { campaign_type: value } }))
  }


  return (
    <div className="flex flex-col flex-1">
      <LabeledSelect options={[...PAGE_TAB_TYPES]}
                     isDisabled={isLoading}
                     value={PAGE_TAB_TYPES.find((t) => t.value === values.type)}
                     onChange={setTabType}
                     label="Content Type"
      />

      <div key={`${values.type}${values.value ? values.value : ''}`}>
        <DynamicSearchSelect
          type={values.type}
          normalCampaignsOnly={true}
          extData={values.value} value={values.obj} onChange={setTabValue} isDisabled={isLoading} label="Search"
          placeholder="Search" />
      </div>

      {[UI_FOCUSED_TYPE_BRAND, UI_FOCUSED_TYPE_CATEGORY, UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN].includes(values.type) && (
        <div className="mt-4">
          <Checkbox
            name="is_quickee"
            value="is_quickee"
            label="Is Quickee"
            isChecked={values.is_quickee || false}
            onChanged={onIsQuickeeChange}
          />
        </div>
      )}


      {/*{*/}
      {/*  values.type === UI_FOCUSED_TYPE_BRAND ?*/}
      {/*    <BrandSearchSelect*/}
      {/*      value={values.obj}*/}
      {/*      extData={values.value}*/}
      {/*      onChange={setTabValue}*/}
      {/*      isDisabled={isLoading}*/}

      {/*    />*/}
      {/*    : values.type === UI_FOCUSED_TYPE_CATEGORY ?*/}
      {/*      <CategorySearchSelect*/}
      {/*        value={values.obj}*/}
      {/*        extData={values.value}*/}
      {/*        onChange={setTabValue}*/}
      {/*        isDisabled={isLoading}*/}
      {/*      />*/}
      {/*      : values.type === UI_FOCUSED_TYPE_PAGE ?*/}
      {/*        <DynamicPagesSelect*/}
      {/*          label="Select Page"*/}
      {/*          value={values.obj}*/}
      {/*          extData={values.value}*/}
      {/*          onChange={setTabValue}*/}
      {/*          isDisabled={isLoading}*/}
      {/*        />*/}

      {/*        : ''*/}
      {/*}*/}
    </div>
  )
}

const MAX_TITLE_LENGTH = 30




